angular.module('zc.projects')

  .component('zcNoPublishPageForm', {
    bindings: {
      project: '=',
      pageType: '=',
      onDestroy: '&',
    },
    templateUrl: '/templates/projects.settings/campaign/no_publish_page_type_form.html',
    controllerAs: 'vm',
    controller: zcNoPublishPageFormController,
  });

zcNoPublishPageFormController.$inject = ['$scope', '$timeout', '$translate', 'PageType'];
function zcNoPublishPageFormController($scope, $timeout, $translate, PageType) {
  const vm = this;

  vm.matchTypes = [
    { name: $translate.instant('projectsSettings.campaign.noPublishPageTypeForm.prefix'), value: 'prefix' },
    { name: $translate.instant('projectsSettings.campaign.noPublishPageTypeForm.full'), value: 'full' },
    { name: $translate.instant('projectsSettings.campaign.noPublishPageTypeForm.partial'), value: 'partial' },
  ];

  vm.isDestroying = false;
  vm.isSaving = false;

  vm.savePageType = () => {
    vm.isSaving = true;

    if(vm.pageType.id) {
      PageType.update({projectId: vm.project.id, id: vm.pageType.id}, { page_type: vm.pageType })
        .then(mergePageType);
    } else {
      PageType.create({projectId: vm.project.id}, { page_type: vm.pageType })
        .then(mergePageType);
    }
  };

  vm.destroyPageType = () => {
    if(!vm.pageType.id) {
      // Apply digest loop by $timeout after destroying the page type
      $timeout(() => vm.onDestroy({pageType: vm.pageType}));
    } else {
      vm.isDestroying = true;
      PageType.destroy(vm.pageType)
        .then(res => {
          vm.onDestroy({pageType: vm.pageType});
          vm.isDestroying = false;
        });
    }
  };

  function mergePageType(res) {
    vm.pageType = _.merge(vm.pageType, res);
    vm.isSaving = false;
    $scope.noPublishPageForm.$setPristine();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.settings/campaign/no_publish_page_type_form.js